export default function About() {
  return (
    <section id="about" className="w-full bg-background-50 pb-16 md:pb-20">
      <div className="w-full px-4 md:px-8">
        <div className="rounded-lg bg-background-100 border border-background-200 px-6 py-10 md:px-12 md:py-14">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
            <div>
              <span className="text-xs font-label tracking-widest text-primary-700">ABOUT</span>
              <h2 className="mt-2 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
                关于本站：一个集中的下载信息页
              </h2>
              <p className="mt-4 text-sm md:text-base leading-7 text-foreground-600">
                本页面的作用是把漫蛙客户端的下载信息集中在一处：你可以在这里了解安卓版、iOS 版与最新版
                的差异、各自的配置要求，以及安装和使用中的常见问题，省去在多个地址之间来回跳转的麻烦。
              </p>
              <p className="mt-3 text-sm leading-7 text-foreground-500">
                页面内容以通用说明为主，具体版本号、文件大小与更新日期请以官方发布的最新信息为准。
              </p>
              <div className="mt-6 flex flex-col sm:flex-row gap-3">
                <a
                  href="#download"
                  className="inline-flex items-center justify-center gap-2 px-5 py-3 rounded-md bg-primary-600 text-background-50 text-sm font-medium hover:bg-primary-700 transition-colors cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-download-2-line"></i>
                  前往下载区
                </a>
                <a
                  href="#faq"
                  className="inline-flex items-center justify-center gap-2 px-5 py-3 rounded-md border border-background-300 text-foreground-900 text-sm font-medium hover:border-primary-400 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-question-line"></i>
                  查看常见问题
                </a>
              </div>
            </div>

            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              {[
                { icon: "ri-shield-keyhole-line", title: "来源核对", desc: "安装前请确认安装包来源与版本号一致。" },
                { icon: "ri-timer-line", title: "版本同步", desc: "留意更新日期，及时获取最新版本。" },
                { icon: "ri-device-line", title: "多端适配", desc: "手机与平板均有对应的安装方式。" },
                { icon: "ri-customer-service-2-line", title: "问题排查", desc: "安装受阻时可参考下方常见问题。" },
              ].map((item) => (
                <li key={item.title} className="rounded-lg bg-background-50 border border-background-200 px-4 py-4">
                  <span className="w-9 h-9 flex items-center justify-center rounded-md bg-accent-100 text-accent-700 text-lg">
                    <i className={item.icon}></i>
                  </span>
                  <h3 className="mt-3 text-sm font-medium text-foreground-950">{item.title}</h3>
                  <p className="mt-1 text-xs leading-5 text-foreground-600">{item.desc}</p>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}